import { gql } from 'graphql-request';
import { orchestrationLayerFetcher } from 'util/OL';

export const fetchEligibleProducts = async (userId) => {
  const legacyUserId = Number(userId);
  const query = gql`
  query UserSubscription($legacyUserId: Int) {
    userSubscription {
      upsellProductsByUser(legacyUserId: $legacyUserId) {
        features
        productId
      }
    }
  }`;

  const { userSubscription: { upsellProductsByUser } } = await orchestrationLayerFetcher(query, { legacyUserId });
  return upsellProductsByUser;
};

export const fetchProductFeaturesByField = async ({ userId, fieldUuid }) => {
  const legacyUserId = Number(userId);
  const query = gql`
  query UserSubscription($fieldUuids: [String!]!, $legacyUserId: Int) {
    userSubscription {
      featuresByFields(fieldUuids: $fieldUuids, legacyUserId: $legacyUserId) {
        features
        fieldId
      }
    }
  }`;

  const {
    userSubscription: { featuresByFields: [productFeatures] }
  } = await orchestrationLayerFetcher(query, { legacyUserId, fieldUuids: [fieldUuid] });
  
  return productFeatures;
};
